export default async function ({ app, route, $cookies, store, $sentry }) {
    try {
      if ('category' in route.query) {
        $cookies.set('onboarding-category', route.query.category)
        $cookies.set('onboarding', true)
      }
      if (!app.$auth.loggedIn) return
      
        const futures = [
            store.dispatch('getDocuments'),
            store.dispatch('getArticles'),
            store.dispatch('getPapers'),
        ]
        await Promise.all(futures)

    } catch (err) {
      const isAuthError = err?.message?.includes('No current user found') ||
        err?.message?.includes('Not authenticated')
      if (!isAuthError) {
        $sentry.captureException(err)
      }
    }
  }
  